import { RootState } from '../types';
import { Language } from '@/types/app';
import { ArticleContent, ApiDefinitionArticle } from '@/types/api-definitions';

export const selectArticlesState = (state: RootState) => state.articles;

export const selectArticlesByApiId = (state: RootState, apiId: string) => 
  state.articles.articlesByApiId[apiId] || [];

export const selectArticlesLoading = (state: RootState, apiId: string) => 
  state.articles.loading[apiId] || false;

export const selectArticlesError = (state: RootState) => state.articles.error;

export const selectHasArticles = (state: RootState, apiId: string) => 
  !!state.articles.articlesByApiId[apiId];

export const selectLocalizedArticles = (state: RootState, apiId: string, language: Language): ArticleContent[] => {
  const articles = selectArticlesByApiId(state, apiId);
  return articles
    .map((article: ApiDefinitionArticle) => 
      article[language] || article.en || article.nl
    )
    .filter((content): content is ArticleContent => !!content);
};
